import { emitEvent } from "utils/utils";
import styles from "./PaymentButtons.module.scss";
import OnlineButton from "./OnlineButton";
import PartsButton from "./PartsButton";

export interface PaymentButtonInterface {
  icon: { systemId: number; count: number };
  title: string;
  type: string;
}
export type PaymentButtonsProps = {
  hash: string;
  buttons: PaymentButtonInterface[];
};

const PaymentButtons = ({ hash, buttons }: PaymentButtonsProps) => {
  const click = (type: string) => {
    emitEvent("widget-pay", { hash, type }, window.top?.document.body);

    return;
  };

  return (
    <div className={styles.paymentsButtonsWrapper}>
      <OnlineButton title="Оплатити" onClick={() => click("1")} />
      <div className={styles.partsButtonsWrapper}>
        {buttons.map(function (btn) {
          return (
            <PartsButton
              title={btn.title}
              icon={btn.icon}
              onClick={() => click(btn.type)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default PaymentButtons;
